import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getArea = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/area/list' });

  return data;
};

export default getArea;
